import React from "react";
import { useTranslation, Trans } from "react-i18next";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="about">
      <img src="/mnt/data/astro.jpeg" alt="Mr. A.R. Kannan" />
      <div style={{ flex: 1 }}>
        <h2>{t('about.title')}</h2>
        <p>
          <Trans i18nKey="about.p1">
            Welcome to <strong>Kannan's Astrohub</strong>, guided by the
            spiritual wisdom of <strong>Mr. A.R. Kannan</strong>. With over six
            years of dedicated practice in astrology, he offers intuitive guidance
            rooted in divine insight and traditional principles.
          </Trans>
        </p>
        <p style={{ color: "var(--muted)" }}>
          {t('about.p2')}
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
